import { Component, inject } from '@angular/core';
import { ShiftGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ShiftGroupCreateDto,
  ShiftGroupDto,
  ShiftGroupExcelDownloadDto,
  ShiftGroupUpdateDto,
} from '../proxy/controlling/dtos/shift-group';
import { SHIFTGROUP_CONFIG, SHIFTGROUP_FIELDS } from './shift-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-shift-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ShiftGroupService, ConfirmationService],
  templateUrl: './shift-group.html',
  styleUrl: './shift-group.scss',
})
export class ShiftGroup extends BaseCrudComponent<
  ShiftGroupDto,
  ShiftGroupCreateDto,
  ShiftGroupUpdateDto,
  ShiftGroupExcelDownloadDto
> {
  service = inject(ShiftGroupService);
  config = SHIFTGROUP_CONFIG;
  fields = SHIFTGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: ShiftGroupDto): ShiftGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ShiftGroup';
  }
}
